<svg  viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 16C9.10457 16 10 15.1046 10 14H6C6 15.1046 6.89543 16 8 16Z" fill="black"/>
<path d="M8.99516 1.09903C8.99836 1.06646 9 1.03342 9 1C9 0.447715 8.55228 0 8 0C7.44772 0 7 0.447715 7 1C7 1.03342 7.00164 1.06646 7.00484 1.09904C4.7202 1.56045 3.00002 3.57934 3.00002 6C3.00002 7.0976 2.5 12 1 13H15C13.5 12 13 7.0976 13 6C13 3.57932 11.2798 1.56042 8.99516 1.09903Z" fill="black"/>
</svg>
